import moment from 'moment'
import { DatePeriod } from '../../../../model'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  BalanceZoneStoreModel,
  CompanyStoreModel,
  getAppConfigurationValue
} from '../../../../redux'
import AxiosInstance from '../../../http-config'
import {
  APIProceduresFetchAllRequest,
  NewProcedure,
  AddProcedureDocument,
  Procedure
} from './model/Procedure'

export class ApiProcedures {
  FetchAll = async (request: APIProceduresFetchAllRequest): Promise<Procedure[]> => {
    const bodyRequest = {
      initDate: request?.datePeriod?.start
        ? moment(request.datePeriod.start).format('YYYY-MM-DD')
        : undefined,
      endDate: request?.datePeriod?.end
        ? moment(request.datePeriod.end).format('YYYY-MM-DD')
        : undefined,
      subjectId: request.clientId,
      company: request?.company?.id,
      balanceZone: request?.balanceZone?.id
    }

    return await AxiosInstance.post(
      `${getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)}/api/procedures`,
      // `https://localhost:63910/api/procedures`,
      bodyRequest
    ).then(response => {
      return response.data
    })
  }

  Fetch = async (idProcedure: number | undefined): Promise<Procedure> => {
    return await AxiosInstance.get(
      `${getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)}/api/procedures?id=${idProcedure}`
      // `https://localhost:63910/api/procedures?id=${idProcedure}`
    ).then(response => {
      return response.data
    })
  }

  FetchByCodOrigen = async (
    cupsId: number | undefined,
    codOrigen: string | undefined
  ): Promise<Procedure[]> => {
    return await AxiosInstance.get(
      `${getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)}/api/procedures/FetchByCupsAndCodOrigen?cupsId=${cupsId}&codOrigen=${codOrigen}`
      // `https://localhost:63910/api/procedures/FetchByCupsAndCodOrigen?cupsId=${cupsId}&codOrigen=${codOrigen}`
    ).then(response => {
      return response.data
    })
  }

  Patch = async (request: Procedure): Promise<boolean> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

    return await AxiosInstance.patch(
      `${apiSuffixUrl}/api/procedures(${request.id},'${request.state}')`,
      request
    ).then(() => {
      return true
    })
  }

  Post = async (request: NewProcedure): Promise<boolean> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/procedures/createprocedure`,
      //`https://localhost:63910/api/procedures/createprocedure`,
      request
    ).then(response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    })
  }

  PostDocumentProcedure = async (
    idProcedure: number,
    request: AddProcedureDocument
  ): Promise<boolean> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/documentsprocedures?idProcedure=${request.idProcedure}`,
      request
    ).then(response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    })
  }

  PatchCloseProcedure = async (idProcedure: number, state: number): Promise<any> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

    const request = { state: state }
    return await AxiosInstance.patch(
      `${apiSuffixUrl}/api/procedures/UpdateStateProcedure(${idProcedure})`,
      request
    ).then(() => {
      return true
    })
  }
}

export const apiPostFetchAnnexedParams = async (request: any): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/AnnexedParams/FetchAnnexedParamsById`,
    `${apiSuffixUrl}/api/AnnexedParams/FetchAnnexedParamsById`,
    request
  ).then(response => response.data)
}
